import * as React from 'react';
import {Console} from '../../console/console';
import {IConsoleMessage, ITests} from '../../../redux/modules/console/reducer';

import './styles.sass';

export interface ISessionEditorConsoleProps {
  showConsoleScrollHint?: boolean;
  hasErrorCompilation: boolean;
  messages: Array<IConsoleMessage>;
  runTests: boolean;
  hasTests: boolean;
  running: boolean;
  tests: ITests;
  toggleBottomBar?: () => void;
  consoleScroll?: () => void;
}

export const SessionEditorConsole: React.StatelessComponent<ISessionEditorConsoleProps> = ({
  hasErrorCompilation,
  messages,
  runTests,
  hasTests,
  running,
  tests,
  showConsoleScrollHint,
  toggleBottomBar,
  consoleScroll,
}: ISessionEditorConsoleProps) => (
    <Console
      hasErrorCompilation={hasErrorCompilation}
      messages={messages}
      hasTests={hasTests}
      runTests={runTests}
      running={running}
      tests={tests}

      showConsoleScrollHint={showConsoleScrollHint}
      ackConsoleScroll={consoleScroll}
      toggle={toggleBottomBar}
    />
  );
